import { Layout, LayoutProps } from "react-admin";
import { AereAppBar } from "./AereAppBar";

function EmptyMenu() {
  return null;
}

export function AereLayout(props: LayoutProps) {
  return (
    <Layout
      {...props}
      appBar={AereAppBar}
      menu={EmptyMenu}
      sx={{
        "& .RaSidebar-root": {
          display: "none",
          width: 0,
          minWidth: 0,
        },
        "& .RaLayout-contentWithSidebar": {
          marginLeft: 0,
        },
        "& .RaLayout-contentWithSidebar > .MuiDrawer-root": {
          display: "none",
          width: 0,
        },
        "& .MuiDrawer-docked": {
          width: "0 !important",
          minWidth: "0 !important",
        },
      }}
    />
  );
}
